import ChatCreateGroupInfo from '@/screens/ChatCreateGroupInfo';

export default function PrivateChatCreateGroupInfoRoute() {
  return <ChatCreateGroupInfo />;
}
